import { createContext } from 'react';

export const PresenceContext = createContext({
  peers: [],
  me: null,
  setViewingDealId: () => {},
  colorFor: () => '#64748b',
});
